export default {"src":"/_next/static/media/compute-engine.7519d052.svg","height":682,"width":682,"blurWidth":0,"blurHeight":0};